import React, { FC } from 'react'
import { Form, Modal } from 'react-bootstrap'

interface SimilerReasoningModalProps {
  show: boolean
  onHide: () => void
  data: {
    applicationReference: string
    programType: string
    scheme: string
    descriptions: string[]
  }
}

const SimilerReasoningModal: FC<SimilerReasoningModalProps> = ({
  show,
  onHide,
  data,
}) => {
  const { applicationReference, programType, scheme, descriptions } = data

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-sm"
      dialogClassName="custom-modal-layout-similiar-reasoning"
      contentClassName="custom-modal-content"
      centered
    >
      <Modal.Header
        closeButton
        closeVariant="white"
        className="custom-modal-header"
      >
        <Modal.Title id="example-modal-sizes-title-sm">
          Reasoning Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form id="reasoning-details-form">
          <p>
            <strong>Application Reference:</strong> {applicationReference}
          </p>
          <p>
            <strong>Program Type:</strong> {programType}
          </p>
          <p>
            <strong>Scheme:</strong> {scheme}
          </p>
          <p>
            <strong>
              {(descriptions && descriptions.length === 1) ||
              (descriptions && descriptions.length === 0)
                ? 'Similar Record found in the following field:'
                : 'Similar Records found in the following fields:'}
            </strong>
          </p>
          <ul>
            {descriptions && descriptions.length > 0 ? (
              descriptions.map((desc: string, index: number) => (
                <li key={index}>{desc}</li>
              ))
            ) : (
              <li>No reasons available.</li>
            )}
          </ul>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <button className="cancel-button" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default SimilerReasoningModal
